// extracted by mini-css-extract-plugin
export default {"wrapper":"Pay_wrapper__1PrEg","header":"Pay_header__1P03s","goBack":"Pay_goBack__QCZEc","container":"Pay_container__eMahL"};